import {
  Box,
  Button,
  Card,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import { poppins300 } from 'theme/common.style';
import VendorStageTwoBegun from 'assets/images/VendorStageTwoBegun.png';
import { useHistory } from 'react-router-dom';

const ConfirmTicIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_38210_159899)">
        <path
          d="M5 12L10 17L20 7"
          stroke="#4898F8"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_38210_159899">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const StageTwoTimerCommencedAgent = (props) => {
  let { bannerDetails, isAgentDashboard, setOpenCommenceStageTwo } = props;

  const theme = useTheme();
  const history = useHistory();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));

  let PropertyId = bannerDetails?.propertyId;

  const onPropertyClick = (propertyId) => {
    if (propertyId) {
      history.push({
        pathname: `dashboard/view-dashboard/${propertyId}`,
        state: {
          propertyIds: true,
          dashboardCommenceStage2: true,
        },
      });
    }
  };

  const HandleOpenStageTwoPopup = () => {
    setOpenCommenceStageTwo(true);
  };

  return (
    <>
      <Grid
        container
        sx={{
          scrollbarWidth: 'none',
          background: 'white',
          margin: '0 auto',
          zIndex: 1,
        }}
      >
        <Card
          variant="outlined"
          sx={{
            background: 'rgba(33, 132, 253, 0.8)',
            width: '100%',
            borderRadius: '20px',
            p: matchessm ? 0 : 2,
            display: 'flex',
            flexDirection: 'row',
            height: matchessm ? 390 : matchesmd ? 330 : 300,
          }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={12} md={8} display="flex" alignItems="center">
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'start',
                  width: '100%',
                  px: matchessm ? 1.5 : 3,
                  gap: matchessm ? 2.5 : 0.6,
                }}
              >
                <Typography
                  sx={{
                    color: '#FFF',
                    fontWeight: 300,
                    fontSize: matchessm ? '12px' : '14px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                    marginTop: '-10px',
                  }}
                >
                  {bannerDetails?.propertyAddress}
                </Typography>

                <Typography
                  sx={{
                    fontSize: !matches450 ? '32px' : '20px',
                    fontWeight: 600,
                    color: '#FFF',
                    fontFamily: 'poppins',
                  }}
                >
                  Commence Stage 2 Now!
                </Typography>

                <Typography
                  sx={{
                    fontSize: matchessm ? '14px' : '16px',
                    ...poppins300,
                    marginTop: matchessm ? '0px' : '15px',
                    color: 'rgba(255, 255, 255, 1)',
                  }}
                >
                  Offer and acceptance has been received for &nbsp;
                  <span
                    style={{
                      alignItems: 'center',
                      color: 'rgba(255, 255, 255, 1)',
                      fontWeight: matchessm ? 400 : 700,
                      fontSize: matchessm ? '14px' : '16px',
                      fontFamily: 'poppins',
                      textTransform: 'capitalize',
                    }}
                  >
                    {bannerDetails?.propertyAddress}.
                  </span>
                  &nbsp; Buyers are most active now. This is typically the best
                  time to commence Stage 2 and maximise the property sale value.
                </Typography>

                <Box display="flex" alignItems="center" mt={2.5}>
                  <Button
                    startIcon={<ConfirmTicIcon />}
                    onClick={() => {
                      if (isAgentDashboard) {
                        onPropertyClick(PropertyId);
                      } else {
                        HandleOpenStageTwoPopup();
                      }
                    }}
                    sx={{
                      px: 4,
                      height: matchessm ? 35 : 42,
                      borderRadius: '5px',
                      fontSize: matchessm ? '12px' : '14px',
                      textTransform: 'none',
                      border: '1px solid #E6F2FF',
                      backgroundColor: '#FFF',
                      color: '#2184FD',
                      fontWeight: 400,
                      fontFamily: 'poppins',
                      '&:hover': {
                        bgcolor: '#FFFFFF',
                        color: '#2184FD',
                      },
                    }}
                  >
                    Commence Stage 2
                  </Button>
                </Box>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              display={matchesmd ? 'none' : 'block'}
              textAlign="center"
            >
              <img
                src={VendorStageTwoBegun}
                alt="VendorStageTwoBegun"
                style={{ objectFit: 'contain', height: '275px' }}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </>
  );
};

export default StageTwoTimerCommencedAgent;
